export const Endpoint = () => `/api/v3/scan/removebyip/`;
export const Csrf = () => `/api/v3/scan/token/`;
export declare const QueryKey: never;
export type Payload = { ipaddress: string };
export type Response = void;
